export const getWebhooksInfoLink = () => 'https://developer.systeme.io/docs/webhooks'
